import React, { useState, useEffect, useRef } from 'react'
import { WebinarCards, FutureWebinarPanel } from 'newComponents'
import classNames from 'classnames'
import starsBg from '../../../images/webinars/stars_bg.jpg'
import '../../../styles/trajectory.scss'
import './styles.scss'

const FutureWebinarsPanel = (props) => {
  const { futureWebinars } = props
  const [currentPanel, setCurrentPanel] = useState(0)

  const timeoutRef = useRef()

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      const nextIndex = currentPanel === futureWebinars.length - 1 ? 0 : currentPanel + 1
      setCurrentPanel(nextIndex)
    }, 6000)
  }, [currentPanel])

  const handleClick = (event, index) => {
    event.preventDefault()
    clearTimeout(timeoutRef.current)
    setCurrentPanel(index)
  }

  return (
    <>
      <div className="container content columns future-webinar-panel-container is-hidden-mobile">
        {futureWebinars.map((futureWebinar, index) => {
          const { data } = futureWebinar
          const { title } = data
          return (
            <FutureWebinarPanel
              futureWebinar={futureWebinar}
              imagesData={starsBg}
              key={title.text}
              isActive={currentPanel === index}
            />
          )
        })}
      </div>
      <div className="container content columns is-multiline cards is-hidden-tablet">
        <WebinarCards webinars={{ future: futureWebinars }} future />
      </div>

      <div className="container content is-centered future-webinar-selectors is-hidden-mobile">
        {futureWebinars.length > 1 &&
          futureWebinars.map((futureWebinar, index) => {
            const { data } = futureWebinar
            const { title } = data
            return (
              <a
                className={classNames('future-webinar-selector', {
                  'future-webinar-selector-current': currentPanel === index
                })}
                href="#next"
                key={title.text}
                onClick={(event) => handleClick(event, index)}
              >
                {index + 1}
              </a>
            )
          })}
      </div>
    </>
  )
}

export default FutureWebinarsPanel
